import script from "./MantenedorAsignacionesHub.vue?vue&type=script&setup=true&lang=js"
export * from "./MantenedorAsignacionesHub.vue?vue&type=script&setup=true&lang=js"

import "./MantenedorAsignacionesHub.vue?vue&type=style&index=0&id=e140c2e6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e140c2e6"]])

export default __exports__